import React from "react";

const ListSkeleton = () => {
    return <div className="flex flex-col">
        <div className="skeleton animate-wave h-56 w-full rounded-lg bg-slate-150 dark:bg-navy-500"></div>
        <div className="skeleton animate-wave h-28 mt-6 w-full rounded-lg bg-slate-150 dark:bg-navy-500"></div>
        <div className="flex space-x-5 py-4">
            <div className="flex flex-1 flex-col justify-between py-2">
                <div className="skeleton animate-wave h-10 mb-1 w-12/12 rounded-lg bg-slate-150 dark:bg-navy-500"></div>
            </div>
            <div className="flex flex-1 flex-col justify-between py-2">
                <div className="skeleton animate-wave h-10 mb-1 w-12/12 rounded-lg bg-slate-150 dark:bg-navy-500"></div>
            </div>
        </div>
    </div>
}

export default ListSkeleton;
